var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessesRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 89,
    viewBox: "0 0 100 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4611 29.2031L32.8556 0H10L0.45 25.0312C0.155555 25.9212 0 26.8446 0 27.8125C0 33.9535 6.38889 38.9375 14.2833 38.9375C21.5611 38.9375 27.5778 34.6878 28.4611 29.2031ZM50 38.9375C57.8889 38.9375 64.2833 33.9535 64.2833 27.8125C64.2833 27.5844 64.2667 27.3564 64.2556 27.1394L61.4278 0H38.5722L35.7389 27.1172C35.7258 27.3487 35.7183 27.5806 35.7167 27.8125C35.7167 33.9535 42.1111 38.9375 50 38.9375ZM77.7778 44.7559V66.75H22.2222V44.7892C19.7889 45.6681 17.1111 46.1688 14.2833 46.1688C13.2 46.1688 12.15 46.0408 11.1111 45.8962V81.2125C11.1111 85.4956 14.6056 89 18.8778 89H81.1111C85.3889 89 88.8889 85.4901 88.8889 81.2125V45.9017C87.8387 46.0632 86.779 46.1542 85.7167 46.1743C83.0077 46.1716 80.3204 45.6914 77.7778 44.7559ZM99.5555 25.0312L89.9944 0H67.1444L71.5333 29.1586C72.3889 34.6655 78.4056 38.9375 85.7167 38.9375C93.6056 38.9375 100 33.9535 100 27.8125C100 26.8446 99.8444 25.9212 99.5555 25.0312Z",
    fill: "#FF2D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessesRed);
export default __webpack_public_path__ + "static/media/businessesRed.dbedfe635fe469d176d1c53ad835e562.svg";
export { ForwardRef as ReactComponent };